import api from "@/api";

const namespaced = true

const state = {
  cargoCapacityUtilizationData: [],
  routes: []
}

const getters = {
  cargoCapacityUtilizationData: (state) => state.cargoCapacityUtilizationData,
  routes: (state) => state.routes
}

const mutations = {
  SET_CARGO_CAPACITY_UTILIZATION_DATA: (state, payload) => {
    state.cargoCapacityUtilizationData = payload
  },
  SET_ROUTES: (state, payload) => {
    state.routes = payload
  }
}

const actions = {
  async fetchCargoCapacityUtilization({ commit }, payload) {
    try {
      const { data } = await api.getCargoCapacityUtilization(payload)

      if (data.error) {
        commit('SET_CARGO_CAPACITY_UTILIZATION_DATA', [])
        return
      }

      commit('SET_CARGO_CAPACITY_UTILIZATION_DATA', data)
    } catch (err) {
      throw err
    }
  },
  async fetchRoutes({ commit }) {
    try {
      const { data } = await api.getCargoCapacityUtilRoutes()
  
      if (data.error) {
        commit('SET_ROUTES', [])
        return
      }
  
      commit('SET_ROUTES', data)
    } catch (err) {
      throw err
    }
  }
}

export default { namespaced, state, getters, mutations, actions }